<template>
    <div class="action-container clearfix">
        <transition v-bind:name="transitionValue">
            <div v-if="isActive == true" class="btn-group btn-confirm-delete">
                <a class="btn btn-danger btn-sm" href="#" @click="remove()"><span>&check;</span></a>
                <div class="btn btn-outline-danger btn-sm" @click="cancel()"><i class="fa fa-times" aria-hidden="true"></i></div>
            </div>
            <button style="border-left: none !important;width: 100%;" class="btn btn-sm btn-danger btn-start-confirmation" @click="confirm()" v-if="isActive == false"><span>{{label}}</span></button>
        </transition>
    </div>
</template>
<script>
export default {
    name: 'delete-toggle',
    data() {
        return {
            transitionValue: 'slide',
            isActive: false
        }
    },
    props: {
        label: {
            type: String,
            default: 'Disable'
        }
    },
    methods: {
        cancel () {
            this.isActive = false;
            this.transitionValue = 'slide'
        },
        confirm(){
            this.isActive = true;
            this.transitionValue = 'slide-reverse'
        },
        remove () {
            this.$emit('remove');
        }
    }
}
</script>
<style lang="scss" scoped>
.slide-reverse-leave-active,
    .slide-reverse-enter-active,
    .slide-leave-active,
    .slide-enter-active {
      transition: 0.4s;
    }
    .slide-enter {
      transform: translate(-100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(100%, 0);
    }

    .slide-reverse-enter {
      transform: translate(100%, 0);
      span{
        transition: opacity 0.4s;
        opacity: 1;
      }
    }
    .slide-reverse-leave-to {
        span{
            transition: opacity 0.4s;
            opacity: 0;
        }
      transform: translate(-100%, 0);
    }

    .expand-enter-active,
    .expand-leave-active {
      transition: all 0.2s;
      max-height: 145px;
      margin-bottom: 15px;
    }
    .expand-enter,
    .expand-leave-to
    {
      opacity: 0;
      max-height: 0px;
      margin-bottom: 0;
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

    .btn-confirm-delete{
        .btn{
            padding: 11px 8px 9px 8px;
            &:last-child{
                z-index: 10;
                // border-left:1px solid #ff9a9a;
            }
        }
    }
    .btn-start-confirmation{
        width: 100%;
    }
    .btn-confirm-delete {
        width: 100%;
        .btn{
            width: 100%;
        }
    }
    .btn-outline-danger{
        border-color: #AB5755;
        color:#AB5755;

    }
    .action-container{
        position: relative;
        border-left: 1px solid #f5f6fa;
        overflow: hidden;
        background-color: #AB5755;
        border-radius: 2px;
        width: 54px;
        height: 27px;
        .btn-confirm-delete, .btn-start-confirmation{
            position: absolute;
            width: 100%;
            top: 0;
        }
        .btn-start-confirmation{
            padding: 5px 13px;
        }
        .btn {
            font-size: 9px;
        }
    }
</style>
